// extracted by mini-css-extract-plugin
export default {"spinner":"CubeSpinner_spinner__igUYf","spinner-y0fdc1":"CubeSpinner_spinner-y0fdc1__Z2sfH"};